import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Controller genérico para selects con búsqueda remota (Tom Select).
// Soporta single select y multiselect con tags.
//
// Uso single select:
//   select data-controller="manage--tom-select"
//          data-manage--tom-select-url-value="/search.json"
//
// Uso multiselect:
//   select multiple data-controller="manage--tom-select"
//          data-manage--tom-select-url-value="/search.json"
//
// El endpoint debe retornar JSON: [{ id: 1, name: "Texto" }, ...]
export default class extends Controller {
  static values = {
    url: String,
    labelField: { type: String, default: "name" },
    valueField: { type: String, default: "id" },
    searchField: { type: String, default: "name" },
    preload: { type: Boolean, default: true },
    placeholder: { type: String, default: "Seleccionar..." },
    create: { type: Boolean, default: false },
    minChars: { type: Number, default: 0 }
  }

  connect() {
    if (this.element.tomselect) return

    this.select = new TomSelect(this.element, this.#config())
  }

  disconnect() {
    if (this.select) {
      this.select.destroy()
      this.select = null
    }
  }

  // --- Private ---

  #config() {
    const isMultiple = this.element.multiple
    const config = {
      plugins: isMultiple ? { remove_button: { title: "Quitar" } } : {},
      placeholder: this.placeholderValue,
      create: this.createValue,
      hideSelected: true,
      closeAfterSelect: true
    }

    if (this.hasUrlValue) {
      Object.assign(config, {
        valueField: this.valueFieldValue,
        labelField: this.labelFieldValue,
        searchField: [this.searchFieldValue],
        loadThrottle: 300,
        preload: this.preloadValue,
        dropdownParent: "body",
        load: (query, callback) => {
          if (query.length < this.minCharsValue) return callback()

          fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`, {
            headers: { "Accept": "application/json" }
          })
            .then(r => r.json())
            .then(callback)
            .catch(() => callback())
        },
        render: {
          no_results: () => '<div class="ts-no-results">Sin resultados</div>'
        }
      })
    }

    return config
  }
}
